/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * File Type SVG Icons
 */
import { ReactComponent as AudioFile } from "assets/images/icons/file/audio-file.svg";
import { ReactComponent as BinaryFile } from "assets/images/icons/file/binary-file.svg";
import { ReactComponent as CertificateFile } from "assets/images/icons/file/certificate-file.svg";
import { ReactComponent as CodeFile } from "assets/images/icons/file/code-file.svg";
import { ReactComponent as CsvFile } from "assets/images/icons/file/csv-file.svg";
import { ReactComponent as DocFile } from "assets/images/icons/file/document-file.svg";
import { ReactComponent as ExcelFile } from "assets/images/icons/file/excel-file.svg";
import { ReactComponent as ImageFile } from "assets/images/icons/file/image-file.svg";
import { ReactComponent as PdfFile } from "assets/images/icons/file/pdf-file.svg";
import { ReactComponent as PowerpointFile } from "assets/images/icons/file/powerpoint-file.svg";
import { ReactComponent as QuestionFile } from "assets/images/icons/file/question-file.svg";
import { ReactComponent as TextLinesFile } from "assets/images/icons/file/text-lines-file.svg";
import { ReactComponent as VideoFile } from "assets/images/icons/file/video-file.svg";
import { ReactComponent as WordFile } from "assets/images/icons/file/word-file.svg";
import { ReactComponent as XmlFile } from "assets/images/icons/file/xml-file.svg";
import { ReactComponent as ZipFile } from "assets/images/icons/file/zip-file.svg";

const files = {
    PdfFile,
    AudioFile,
    BinaryFile,
    CertificateFile,
    CodeFile,
    CsvFile,
    DocFile,
    ExcelFile,
    ImageFile,
    QuestionFile,
    TextLinesFile,
    PowerpointFile,
    VideoFile,
    WordFile,
    XmlFile,
    ZipFile,
};

export { files };
